module.exports = __webpack_public_path__ + "static/media/logo.4d2e8d2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 308
// module chunks = 0